
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('../assets/modules/jquery.min.js');
// window.Popper = require('../assets/modules/popper.js');
// window.bootstrap = require('../assets/modules/bootstrap/js/bootstrap.min.js');


// TEMPLATE CSS
import '../assets/modules/bootstrap/css/bootstrap.min.css'
import '../assets/css/style.css'
import '../assets/css/custom.css'
import '../assets/css/components.css'
// TEMPLATE JS


// WEBPACK FOOTER //
// ./src/router/bootstrap.js